/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form ? this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]') : [];
      this.trigger = this.querySelector('[data-localization-trigger]');
      this.flag = this.querySelector('[data-localization-flag]');
      this.modal = this.querySelector('[data-localization-modal]');
      this.overlay = this.querySelector('[data-localization-overlay]') || this.querySelector('.side-panel-overlay');
      this.closeBtn = this.querySelector('[data-localization-close]');
      this.pickers = this.querySelectorAll('[data-picker]');
      this.lastFocused = null;

      this.inputs.forEach(item => item.addEventListener('change', this.onInputChange.bind(this)));
      this.syncTriggerFlag();
      this.initPickers();

      if (this.trigger && this.modal) {
        this.trigger.addEventListener('click', this.openModal.bind(this));
      }
      if (this.overlay) this.overlay.addEventListener('click', this.closeModal.bind(this));
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeModal.bind(this));
      document.addEventListener('keydown', this.onKeyDown.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this), true);
    }

    onSubmitHandler(event) {
      if (!this.form) return;
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
        return;
      }
      this.form.submit();
    }

    onInputChange(event) {
      this.syncTriggerFlag();
      this.onSubmitHandler(event);
    }

    initPickers() {
      this.populateFlagEmojis();
      this.pickers.forEach((picker) => {
        var trigger = picker.querySelector('[data-picker-trigger]');
        var menu = picker.querySelector('.thb-picker__menu');
        var options = picker.querySelectorAll('[data-picker-value]');

        if (trigger && menu) {
          trigger.addEventListener('click', function () {
            var isOpen = picker.classList.contains('is-open');
            document.querySelectorAll('.thb-picker.is-open').forEach(function (openPicker) {
              if (openPicker !== picker) openPicker.classList.remove('is-open');
            });
            picker.classList.toggle('is-open', !isOpen);
            trigger.setAttribute('aria-expanded', String(!isOpen));
            menu.setAttribute('aria-hidden', String(isOpen));
          });
        }

        options.forEach((option) => {
          option.addEventListener('click', this.onPickerSelect.bind(this));
        });
      });
    }

    populateFlagEmojis() {
      this.querySelectorAll('[data-flag-iso]').forEach((el) => {
        el.textContent = this.flagEmoji(el.getAttribute('data-flag-iso'));
      });
    }

    onPickerSelect(event) {
      var button = event.currentTarget;
      var targetName = button.getAttribute('data-picker-target');
      var value = button.getAttribute('data-picker-value');
      var picker = button.closest('[data-picker]');
      var input = this.form ? this.form.querySelector('select[name="' + targetName + '"]') : null;
      if (!input || !value) return;

      input.value = value;
      this.syncTriggerFlag();
      if (picker) picker.classList.remove('is-open');
      if (picker) {
        var trigger = picker.querySelector('[data-picker-trigger]');
        var menu = picker.querySelector('.thb-picker__menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.setAttribute('aria-hidden', 'true');
      }
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }

    syncTriggerFlag() {
      if (!this.flag || !this.form) return;
      var countryInput = this.form.querySelector('select[name="country_code"]');
      if (!countryInput) return;
      var value = countryInput.value || '';
      this.flag.textContent = this.flagEmoji(value);
      var currentFlag = this.querySelector('[data-picker-current-flag]');
      if (currentFlag) currentFlag.textContent = this.flagEmoji(value);
    }

    flagEmoji(iso) {
      if (!iso || iso.length !== 2) return '🌐';
      var a = iso.toUpperCase().charCodeAt(0) - 65 + 0x1F1E6;
      var b = iso.toUpperCase().charCodeAt(1) - 65 + 0x1F1E6;
      return String.fromCodePoint(a) + String.fromCodePoint(b);
    }

    openModal() {
      if (!this.modal) return;
      this.lastFocused = document.activeElement;
      this.modal.setAttribute('aria-hidden', 'false');
      this.modal.classList.add('active');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('thb-localization-modal-open');
      setTimeout(() => {
        var close = this.modal.querySelector('[data-localization-close]');
        if (close && close.focus) close.focus();
      }, 50);
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.setAttribute('aria-hidden', 'true');
      this.modal.classList.remove('active');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('thb-localization-modal-open');
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
    }

    onDocumentClick(event) {
      if (!this.modal || this.modal.getAttribute('aria-hidden') !== 'false') return;
      if (event.target.closest('[data-localization-trigger]')) return;
      if (event.target.closest('[data-picker]')) return;
      if (this.modal.contains(event.target)) return;
      this.querySelectorAll('.thb-picker.is-open').forEach(function (picker) {
        picker.classList.remove('is-open');
        var trigger = picker.querySelector('[data-picker-trigger]');
        var menu = picker.querySelector('.thb-picker__menu');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.setAttribute('aria-hidden', 'true');
      });
      this.closeModal();
    }

    onKeyDown(event) {
      if (!this.modal || this.modal.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
